import React from 'react';
import { useDropzone } from 'react-dropzone';
import { getFormItemClassName } from '../../helpers/form';
import { useUploader } from '../../hooks/uploader/useUploader';
import { IFormItemProps } from '../../types/components/form';
import { IUploaderFileResponse } from '../../types/components/uploader';
import { IUploaderLayout } from '../../types/layout/uploader';
import Loader from '../loader';
import UploadedFile from './uploaded-file';
import { getFileName } from '../../helpers/uploader';

function Uploader(props: IUploaderLayout & IFormItemProps) {
    const { additionalClassName, disabled } = props;

    const {
        deleteFile, idOwner, uploading, uploadedFiles, loading, onFileDrop,
    } = useUploader(props);

    const { getRootProps, getInputProps } = useDropzone({
        disabled,
        onDrop: onFileDrop,
    });

    const getFilteredUploadedFiles = () => uploadedFiles.filter((el) => {
        const fileName = getFileName(el);
        return !el.name.replace(fileName, '').includes('[html-editor]-');
    });

    const renderListItem = (file: IUploaderFileResponse) => (
        <UploadedFile key={file.idFile} file={file} idOwner={idOwner} onDeleteClick={deleteFile} />
    );

    const renderFilesList = () => React.Children.toArray(getFilteredUploadedFiles().map(renderListItem));

    return (
        <>
            <Loader loading={loading} />
            {React.createElement('div', {
                ...getRootProps(),
                className: getFormItemClassName('form-item-uploader text-center pb-4 pt-4', additionalClassName),
                disabled: disabled || uploading,
            }, uploading ? [
                <div className="d-flex justify-content-center align-items-center">
                    <span>Загрузка файлов</span>
                    <div className="ml-2 spinner-border text-primary" role="status" style={{ width: 20, height: 20 }} />
                </div>,
            ] : [
                <input {...getInputProps()} />,
                <span>Переместите файлы, чтобы загрузить</span>,
            ])}
            {/* {filesToUpload.length > 0 && filesToUpload.map((file, index) => (file.type.includes('image') ? (
                <div className={getFormItemClassName('form-item-uploader-files mt-2 p-2', additionalClassName)}>
                    <ImageToUpload key={file.name} file={file} onUploadClick={() => uploadFile(index)} />
                </div>
            ) : null))} */}
            {getFilteredUploadedFiles().length > 0 && (
                <div className={getFormItemClassName('form-item-uploader-files mt-2 p-2', additionalClassName)}>
                    {renderFilesList()}
                </div>
            )}
        </>
    );
}

export default Uploader;
